module.exports = __webpack_public_path__ + "static/media/string.8c5d2929.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/createReactApp/string.png
// module id = 55
// module chunks = 0